(function () {
  function init(root) {
    if (root.dataset.vgReady) return;
    root.dataset.vgReady = '1';
    var track = root.querySelector('.vg-g__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.vg-g__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.vg-g__thumb'));
    var thumbList = root.querySelector('.vg-g__thumbs');
    var dialog = root.querySelector('.vg-lightbox');
    var cur = 0, timer;
    function setActive(i) {
      cur = i;
      thumbs.forEach(function (t, k) {
        if (k === i) {
          t.setAttribute('aria-current', 'true');
          if (thumbList.scrollWidth > thumbList.clientWidth) thumbList.scrollTo({ left: t.parentNode.offsetLeft - thumbList.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
          else if (thumbList.scrollHeight > thumbList.clientHeight) thumbList.scrollTo({ top: t.parentNode.offsetTop - thumbList.clientHeight / 2 + t.offsetHeight / 2, behavior: 'smooth' });
        } else t.removeAttribute('aria-current');
      });
    }
    function go(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== cur && i >= 0 && i < slides.length) setActive(i);
      }, 80);
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    if (!dialog) return;
    var big = dialog.querySelector('.vg-lightbox__img');
    function show(i) {
      i = (i + slides.length) % slides.length;
      if (!slides[i].dataset.zoom) return;
      big.src = slides[i].dataset.zoom;
      big.alt = slides[i].dataset.alt || '';
      cur = i;
    }
    function open() { show(cur); if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', ''); }
    var zoomBtn = root.querySelector('.vg-g__zoom');
    if (zoomBtn) zoomBtn.addEventListener('click', open);
    slides.forEach(function (sl) { sl.addEventListener('click', function () { if (window.matchMedia('(min-width: 990px)').matches) open(); }); });
    dialog.querySelector('.vg-lightbox__close').addEventListener('click', function () { dialog.close(); });
    var prev = dialog.querySelector('.vg-lightbox__prev'), next = dialog.querySelector('.vg-lightbox__next');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.classList.contains('vg-lightbox__inner')) dialog.close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(cur + 1);
      if (e.key === 'ArrowLeft') show(cur - 1);
    });
    dialog.addEventListener('close', function () { go(cur); if (zoomBtn) zoomBtn.focus(); });
  }
  function boot() { document.querySelectorAll('.vg-g').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();